import { generateRandomNumber } from './generateRandomNumber.js';
const generateRandomString = () => `${generateRandomNumber()}`;
export { generateRandomString };
